import React from 'react';

const DoctorCharacter = ({ width = 220, height = 320, style = {} }) => (
  <svg
    viewBox="0 0 220 320"
    width={width}
    height={height}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <radialGradient id="skinGrad" cx="40%" cy="35%" r="60%">
        <stop offset="0%" stopColor="#fde8c0" />
        <stop offset="100%" stopColor="#e8a96a" />
      </radialGradient>
      <radialGradient id="headGrad" cx="38%" cy="32%" r="65%">
        <stop offset="0%" stopColor="#fde8c0" />
        <stop offset="60%" stopColor="#f5c07a" />
        <stop offset="100%" stopColor="#d9924a" />
      </radialGradient>
      <linearGradient id="coatGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#ffffff" />
        <stop offset="55%" stopColor="#f0f0f0" />
        <stop offset="100%" stopColor="#d8d8d8" />
      </linearGradient>
      <linearGradient id="coatShadow" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="rgba(0,0,0,0.12)" />
        <stop offset="100%" stopColor="rgba(0,0,0,0)" />
      </linearGradient>
      <linearGradient id="pantsGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#3a4a6b" />
        <stop offset="100%" stopColor="#1e2a45" />
      </linearGradient>
      <linearGradient id="shoeGrad" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#3a2a1a" />
        <stop offset="100%" stopColor="#1a0e0a" />
      </linearGradient>
      <filter id="dropShadow" x="-20%" y="-20%" width="140%" height="140%">
        <feDropShadow dx="2" dy="4" stdDeviation="3" floodOpacity="0.25" />
      </filter>
    </defs>

    {/* Ground shadow */}
    <ellipse cx="110" cy="313" rx="62" ry="10" fill="rgba(0,0,0,0.18)" />

    {/* === SHOES === */}
    {/* Left shoe (back) */}
    <ellipse cx="90" cy="304" rx="25" ry="11" fill="url(#shoeGrad)" stroke="#0d0d0d" strokeWidth="2" />
    <ellipse cx="90" cy="300" rx="23" ry="8" fill="#4a3220" />
    <path d="M68 302 Q72 296 95 298 Q102 300 100 305 Q82 308 68 302 Z" fill="#5a4030" />
    {/* Shoe shine */}
    <ellipse cx="84" cy="299" rx="8" ry="3" fill="rgba(255,255,255,0.18)" transform="rotate(-10,84,299)" />

    {/* Right shoe (front) */}
    <ellipse cx="128" cy="307" rx="26" ry="11" fill="url(#shoeGrad)" stroke="#0d0d0d" strokeWidth="2" />
    <ellipse cx="128" cy="303" rx="24" ry="8" fill="#4a3220" />
    <path d="M105 305 Q110 298 132 300 Q140 302 139 307 Q120 311 105 305 Z" fill="#5a4030" />
    <ellipse cx="122" cy="301" rx="8" ry="3" fill="rgba(255,255,255,0.18)" transform="rotate(-10,122,301)" />

    {/* === PANTS === */}
    {/* Left leg */}
    <path d="M82 248 Q76 268 75 290 Q80 296 96 295 Q104 293 104 285 Q102 265 98 248 Z"
      fill="url(#pantsGrad)" stroke="#111" strokeWidth="2" strokeLinejoin="round" />
    {/* Highlight on left leg */}
    <path d="M84 250 Q80 270 80 286" stroke="rgba(100,130,200,0.35)" strokeWidth="3" fill="none" strokeLinecap="round" />

    {/* Right leg */}
    <path d="M112 250 Q116 270 118 288 Q122 296 136 294 Q144 292 142 283 Q140 265 136 248 Z"
      fill="url(#pantsGrad)" stroke="#111" strokeWidth="2" strokeLinejoin="round" />
    <path d="M134 252 Q137 272 138 285" stroke="rgba(100,130,200,0.35)" strokeWidth="3" fill="none" strokeLinecap="round" />

    {/* === LAB COAT BODY === */}
    <path d="M58 138 Q48 165 45 210 Q44 235 50 250 L170 250 Q176 235 175 210 Q172 165 162 138 Z"
      fill="url(#coatGrad)" stroke="#111" strokeWidth="2.5" strokeLinejoin="round" />

    {/* Coat left shadow panel */}
    <path d="M58 138 Q50 165 47 210 Q46 235 50 250 L110 250 L110 138 Z"
      fill="url(#coatShadow)" />

    {/* Coat front opening line */}
    <line x1="110" y1="138" x2="110" y2="250" stroke="#ccc" strokeWidth="1.5" strokeDasharray="4,3" />

    {/* Shirt visible in V-neck */}
    <path d="M98 136 L85 160 L110 168 L135 160 L122 136 Z" fill="#4fc3f7" stroke="#0288d1" strokeWidth="1" />

    {/* Tie */}
    <path d="M106 136 L115 136 L118 182 L110 190 L102 182 Z" fill="#1a6fcc" stroke="#0d4f9e" strokeWidth="1.5" />
    <path d="M107 138 L114 138 L112 155 L108 155 Z" fill="#2980d9" />

    {/* Coat left lapel */}
    <path d="M110 138 L78 158 L68 210" fill="none" stroke="#bbb" strokeWidth="1.5" strokeLinecap="round" />
    {/* Coat right lapel */}
    <path d="M110 138 L142 158 L152 210" fill="none" stroke="#bbb" strokeWidth="1.5" strokeLinecap="round" />

    {/* Breast pocket */}
    <rect x="63" y="172" width="25" height="18" rx="3" fill="white" stroke="#ccc" strokeWidth="1.5" />
    {/* Pens in pocket */}
    <line x1="70" y1="172" x2="68" y2="188" stroke="#e53935" strokeWidth="2.2" strokeLinecap="round" />
    <line x1="75" y1="172" x2="73" y2="188" stroke="#2196f3" strokeWidth="2.2" strokeLinecap="round" />
    <line x1="80" y1="172" x2="79" y2="188" stroke="#333" strokeWidth="1.8" strokeLinecap="round" />

    {/* Buttons */}
    <circle cx="110" cy="175" r="3.2" fill="#e8e8e8" stroke="#aaa" strokeWidth="1" />
    <circle cx="110" cy="191" r="3.2" fill="#e8e8e8" stroke="#aaa" strokeWidth="1" />
    <circle cx="110" cy="207" r="3.2" fill="#e8e8e8" stroke="#aaa" strokeWidth="1" />
    <circle cx="110" cy="223" r="3.2" fill="#e8e8e8" stroke="#aaa" strokeWidth="1" />

    {/* Doctor badge / ID */}
    <rect x="123" y="172" width="30" height="20" rx="3" fill="#e3f2fd" stroke="#64b5f6" strokeWidth="1.5" />
    <rect x="123" y="172" width="30" height="7" rx="3" fill="#1976d2" />
    <text x="138" y="179" textAnchor="middle" fontSize="5.5" fill="white" fontFamily="Arial, sans-serif" fontWeight="bold">DR.</text>
    <line x1="127" y1="183" x2="149" y2="183" stroke="#90caf9" strokeWidth="1" />
    <line x1="127" y1="187" x2="145" y2="187" stroke="#90caf9" strokeWidth="1" />

    {/* === ARMS === */}
    {/* Left arm (slightly behind) */}
    <path d="M62 145 Q42 165 38 202 Q37 210 44 214 Q52 218 56 210 Q62 196 65 172"
      fill="none" stroke="url(#coatGrad)" strokeWidth="22" strokeLinecap="round" />
    <path d="M62 145 Q42 165 38 202 Q37 210 44 214 Q52 218 56 210 Q62 196 65 172"
      fill="none" stroke="#111" strokeWidth="24" strokeLinecap="round" opacity="0.12" />
    <path d="M62 145 Q42 165 38 202 Q37 210 44 214 Q52 218 56 210 Q62 196 65 172"
      fill="none" stroke="white" strokeWidth="20" strokeLinecap="round" />
    {/* Left hand */}
    <ellipse cx="43" cy="214" rx="10" ry="8" fill="url(#skinGrad)" stroke="#c08040" strokeWidth="1.5" />

    {/* Right arm holding clipboard */}
    <path d="M158 145 Q178 170 180 208 Q181 218 174 222 Q167 226 163 218 Q158 205 158 182"
      fill="none" stroke="#111" strokeWidth="24" strokeLinecap="round" opacity="0.12" />
    <path d="M158 145 Q178 170 180 208 Q181 218 174 222 Q167 226 163 218 Q158 205 158 182"
      fill="none" stroke="white" strokeWidth="20" strokeLinecap="round" />
    {/* Coat sleeve edge */}
    <path d="M158 145 Q178 170 180 208 Q181 218 174 222 Q167 226 163 218 Q158 205 158 182"
      fill="none" stroke="#ddd" strokeWidth="20" strokeLinecap="round" opacity="0.5" />
    {/* Right hand */}
    <ellipse cx="174" cy="222" rx="10" ry="8" fill="url(#skinGrad)" stroke="#c08040" strokeWidth="1.5" transform="rotate(20,174,222)" />

    {/* === CLIPBOARD === */}
    <rect x="168" y="215" width="38" height="52" rx="5" fill="#f5deb3" stroke="#8b6a1a" strokeWidth="2" filter="url(#dropShadow)" />
    {/* Clipboard clip */}
    <rect x="180" y="209" width="14" height="12" rx="3" fill="#b8860b" stroke="#8b6a1a" strokeWidth="1.5" />
    <rect x="182" y="211" width="10" height="6" rx="2" fill="#d4a017" />
    {/* Paper on clipboard */}
    <rect x="171" y="220" width="32" height="44" rx="2" fill="#fffef8" stroke="#ccc" strokeWidth="1" />
    {/* Medical chart lines */}
    <line x1="175" y1="228" x2="199" y2="228" stroke="#e0e0e0" strokeWidth="1.2" />
    <line x1="175" y1="234" x2="199" y2="234" stroke="#e0e0e0" strokeWidth="1.2" />
    <line x1="175" y1="240" x2="195" y2="240" stroke="#e0e0e0" strokeWidth="1.2" />
    <line x1="175" y1="246" x2="199" y2="246" stroke="#e0e0e0" strokeWidth="1.2" />
    <line x1="175" y1="252" x2="193" y2="252" stroke="#e0e0e0" strokeWidth="1.2" />
    {/* Red cross on clipboard */}
    <path d="M185 223 L185 227 M183 225 L187 225" stroke="#e53935" strokeWidth="2" strokeLinecap="round" />

    {/* === NECK === */}
    <rect x="97" y="118" width="26" height="24" rx="10" fill="url(#skinGrad)" stroke="#c08040" strokeWidth="2" />
    <line x1="110" y1="120" x2="110" y2="140" stroke="rgba(180,110,40,0.2)" strokeWidth="1.5" />

    {/* === STETHOSCOPE === */}
    {/* Earpieces */}
    <path d="M95 125 Q80 140 78 162 Q76 174 84 178"
      fill="none" stroke="#666" strokeWidth="3" strokeLinecap="round" />
    <path d="M125 125 Q140 140 140 162 Q140 174 133 178"
      fill="none" stroke="#666" strokeWidth="3" strokeLinecap="round" />
    <path d="M84 178 Q109 190 133 178"
      fill="none" stroke="#666" strokeWidth="3" strokeLinecap="round" />
    {/* Diaphragm */}
    <circle cx="108" cy="190" r="10" fill="#888" stroke="#444" strokeWidth="2" />
    <circle cx="108" cy="190" r="6.5" fill="#bbb" stroke="#888" strokeWidth="1" />
    <circle cx="108" cy="190" r="3" fill="#999" />

    {/* === HEAD === */}
    <ellipse cx="110" cy="85" rx="52" ry="56" fill="url(#headGrad)" stroke="#111" strokeWidth="2.5" filter="url(#dropShadow)" />

    {/* Head highlight */}
    <ellipse cx="94" cy="65" rx="22" ry="18" fill="rgba(255,255,255,0.22)" transform="rotate(-20,94,65)" />

    {/* Chin shadow */}
    <ellipse cx="110" cy="128" rx="28" ry="10" fill="rgba(0,0,0,0.1)" />

    {/* === HAIR === */}
    {/* Main hair top/back */}
    <path d="M60 72 Q62 28 110 24 Q158 28 160 72 Q145 42 110 40 Q75 42 60 72 Z"
      fill="#2e1f14" stroke="#150f08" strokeWidth="1.5" />
    {/* Hair side left */}
    <path d="M60 72 Q54 86 56 102 Q60 88 66 90 Z"
      fill="#2e1f14" stroke="#150f08" strokeWidth="1" />
    {/* Hair side right */}
    <path d="M160 72 Q166 86 164 102 Q160 88 154 90 Z"
      fill="#2e1f14" stroke="#150f08" strokeWidth="1" />
    {/* Hair highlight */}
    <path d="M84 32 Q110 26 130 34" fill="none" stroke="rgba(120,80,40,0.5)" strokeWidth="4" strokeLinecap="round" />

    {/* === EARS === */}
    {/* Left ear */}
    <ellipse cx="58" cy="88" rx="10" ry="13" fill="url(#skinGrad)" stroke="#c08040" strokeWidth="2" />
    <path d="M60 80 Q55 88 60 96" fill="none" stroke="#c08040" strokeWidth="1.5" strokeLinecap="round" />
    {/* Right ear */}
    <ellipse cx="162" cy="88" rx="10" ry="13" fill="url(#skinGrad)" stroke="#c08040" strokeWidth="2" />
    <path d="M160 80 Q165 88 160 96" fill="none" stroke="#c08040" strokeWidth="1.5" strokeLinecap="round" />

    {/* === EYES & GLASSES === */}
    {/* Eyebrows */}
    <path d="M80 64 Q90 59 100 63" fill="none" stroke="#2e1f14" strokeWidth="3" strokeLinecap="round" />
    <path d="M120 63 Q130 59 140 64" fill="none" stroke="#2e1f14" strokeWidth="3" strokeLinecap="round" />

    {/* Eye whites */}
    <ellipse cx="90" cy="78" rx="13" ry="12" fill="white" stroke="#222" strokeWidth="1.5" />
    <ellipse cx="130" cy="78" rx="13" ry="12" fill="white" stroke="#222" strokeWidth="1.5" />

    {/* Irises */}
    <circle cx="91" cy="79" r="7.5" fill="#5a7fa8" />
    <circle cx="131" cy="79" r="7.5" fill="#5a7fa8" />
    {/* Pupils */}
    <circle cx="92" cy="80" r="4.5" fill="#111" />
    <circle cx="132" cy="80" r="4.5" fill="#111" />
    {/* Eye shines */}
    <circle cx="94" cy="77" r="2" fill="white" />
    <circle cx="134" cy="77" r="2" fill="white" />
    <circle cx="90" cy="82" r="1" fill="rgba(255,255,255,0.5)" />
    <circle cx="130" cy="82" r="1" fill="rgba(255,255,255,0.5)" />

    {/* === GLASSES === */}
    {/* Left lens frame */}
    <ellipse cx="90" cy="79" rx="16" ry="15" fill="rgba(200,220,255,0.08)" stroke="#5c3d11" strokeWidth="2.8" />
    {/* Right lens frame */}
    <ellipse cx="130" cy="79" rx="16" ry="15" fill="rgba(200,220,255,0.08)" stroke="#5c3d11" strokeWidth="2.8" />
    {/* Nose bridge */}
    <path d="M106 79 Q110 77 114 79" fill="none" stroke="#5c3d11" strokeWidth="2.5" strokeLinecap="round" />
    {/* Left temple */}
    <path d="M74 77 Q64 76 58 80" fill="none" stroke="#5c3d11" strokeWidth="2.2" strokeLinecap="round" />
    {/* Right temple */}
    <path d="M146 77 Q156 76 162 80" fill="none" stroke="#5c3d11" strokeWidth="2.2" strokeLinecap="round" />
    {/* Lens shine */}
    <path d="M80 71 Q85 67 91 70" fill="none" stroke="rgba(255,255,255,0.6)" strokeWidth="2" strokeLinecap="round" />
    <path d="M120 71 Q125 67 131 70" fill="none" stroke="rgba(255,255,255,0.6)" strokeWidth="2" strokeLinecap="round" />

    {/* === NOSE === */}
    <path d="M110 88 Q104 100 102 104 Q110 108 118 104 Q116 100 110 88"
      fill="#e89a55" stroke="none" />
    <path d="M103 104 Q110 108 117 104" fill="none" stroke="#c07030" strokeWidth="2" strokeLinecap="round" />

    {/* === MOUTH === */}
    <path d="M92 114 Q110 127 128 114" fill="none" stroke="#9a5030" strokeWidth="2.8" strokeLinecap="round" />
    {/* Teeth */}
    <path d="M95 116 Q110 124 125 116 Q110 119 95 116 Z" fill="white" opacity="0.9" />

    {/* Cheek blush */}
    <ellipse cx="76" cy="102" rx="13" ry="9" fill="rgba(240,120,80,0.22)" />
    <ellipse cx="144" cy="102" rx="13" ry="9" fill="rgba(240,120,80,0.22)" />

    {/* Mirror shine on glasses overlay (subtle) */}
    <ellipse cx="90" cy="79" rx="16" ry="15" fill="none" stroke="rgba(255,255,255,0.12)" strokeWidth="8" />
    <ellipse cx="130" cy="79" rx="16" ry="15" fill="none" stroke="rgba(255,255,255,0.12)" strokeWidth="8" />
  </svg>
);

export default DoctorCharacter;
